export default "__VITE_ASSET__B55N5_Yv__"